<div class="container">
  <mic-breadcrumb id="product-import-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ this.translationService.translate('pointOfSaleText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <form [formGroup]="posDetailsForm">
    <div class="pos-header">
      <h2 class="page-title pos-heading" id="product-import-heading">{{ this.translationService.translate('pointOfSaleText') }}</h2>
      <div class="pos-header-actions">
        <button id="add-button" type="button" mat-flat-button color="primary" class="btn-primary pos-action-button" (click)="save()">
          <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
        </button>
      </div>
    </div>

    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('posConfigText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-rows-3 mt-3">
          <div class="grid grid-cols-4 gap-5 items-center">
            <mat-form-field appearance="fill" id="posName" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('nameText') }}</mat-label>
              <mat-select type="text" [formControlName]="'posName'">
                @for (option of posNameOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="col-span-1 flex items-center gap-2 w-full mb-3 justify-self-end">
              <p id="includeCrnShipping-label" class="pr-5">{{ translationService.translate('includeCrnShippingText') }}</p>
              <mat-slide-toggle id="posIncludeCrnShipping-toggle" formControlName="posIncludeCrnShipping">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
            <div class="col-span-1 flex items-center gap-2 w-full mb-3 justify-self-end">
              <p id="acceptInvoiceResults-label" class="pr-5">{{ translationService.translate('acceptInvoiceResultsFromPosText') }}</p>
              <mat-slide-toggle id="inventoryResultEnable-toggle" formControlName="inventoryResultEnable">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center">
            <mat-form-field appearance="fill" id="partNumber" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('partNumberText') }}</mat-label>
              <mat-select type="text" [formControlName]="'partNumber'">
                @for (option of partNumberOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" id="capCasingPartNum" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('capCasingPartNumberText') }}</mat-label>
              <mat-select type="text" [formControlName]="'capCasingPartNum'">
                @for (option of capCasingOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" id="ioProductNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('ioProductNumberText') }}</mat-label>
              <input id="ioProductNum-input" matInput type="text" [formControlName]="'ioProductNum'" maxlength="15" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="roProductNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('roProductNumberText') }}</mat-label>
              <input id="roProductNum-input" matInput type="text" [formControlName]="'roProductNum'" maxlength="15" />
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center">
            <mat-form-field appearance="fill" id="adjustmentReturnNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('adjustmentReturnNumberText') }}</mat-label>
              <input id="adjustmentReturnNum-input" matInput type="text" [formControlName]="'adjustmentReturnNum'" maxlength="15" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="adjustmentScrapNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('adjustmentScrapNumberText') }}</mat-label>
              <input id="adjustmentScrapNum-input" matInput type="text" [formControlName]="'adjustmentScrapNum'" maxlength="15" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="soProductNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('soProductNumberText') }}</mat-label>
              <input id="soProductNum-input" matInput type="text" [formControlName]="'soProductNum'" maxlength="15" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="npProductNum-field" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('npProductNumberText') }}</mat-label>
              <input id="npProductNum-input" matInput type="text" [formControlName]="'npProductNum'" maxlength="15" />
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('posImportSetupText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-rows-4 mt-3">
          <div class="grid grid-cols-5 gap-5 items-center">
            <div class="col-span-1 flex items-center gap-2 w-full justify-self-end">
              <p id="importFromFile-label" class="pr-5">{{ translationService.translate('importFromFileText') }}</p>
              <mat-slide-toggle id="posImportFromFile-toggle" formControlName="posImportFromFile">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
            <div class="col-span-3 flex items-center justify-end gap-3">
              @if (importJobSummary) { @if (importJobSummary.activeJobCount > 0) {
              <span class="job-status-dot running"></span>
              <span class="pos-job-status-text running">Running...</span>
              } @else if (importJobSummary.lastScheduleTime) {
              <span class="job-status-dot completed"></span>
              <span class="pos-job-status-text">Last run: {{ formatDateWithTimezone(importJobSummary.lastScheduleTime) }}</span>
              } @else {
              <span class="job-status-dot idle"></span>
              <span class="pos-job-status-text">Schedule: {{ importJobSummary.schedule || 'N/A' }} &mdash; Never run</span>
              } } @else if (kubeJobsLoading) {
              <span class="pos-job-status-text">Loading job status...</span>
              } @else {
              <span class="job-status-dot idle"></span>
              <span class="pos-job-status-text">Job status unavailable</span>
              }
            </div>
            <div class="flex justify-end">
              <button
                class="pos-job-button btn-primary"
                id="run-import-button"
                type="button"
                mat-flat-button
                color="primary"
                (click)="runImport()"
                [disabled]="triggeringImport"
              >
                <mat-icon>cloud_download</mat-icon>
                {{ translationService.translate('runImportText') }}
              </button>
            </div>
          </div>
          <div class="grid grid-cols-5 gap-5 items-center">
            <p id="im-fr" class="pr-5 pos-section-label">
              {{ translationService.translate('importJobFrequencyText') }}
            </p>
            <div></div>
            <p id="im-files" class="pr-5 pos-section-label">
              {{ translationService.translate('importFilesText') }}
            </p>
          </div>
          <div class="grid grid-cols-5 gap-5 items-center">
            <mat-radio-group formControlName="posImportOnce" class="flex flex-row gap-4">
              <mat-radio-button id="posImportOnce-daily-radio" [checked]="posDetailsForm.get('posImportOnce').value === 'Y'" value="Y">
                {{ translationService.translate('onceDailyText') }}
              </mat-radio-button>
              <mat-radio-button id="posImportOnce-repeat-radio" [checked]="posDetailsForm.get('posImportOnce').value === 'N'" value="N">
                {{ translationService.translate('repeatDailyText') }}
              </mat-radio-button>
            </mat-radio-group>
            @if (posDetailsForm.get('posImportOnce').value === 'Y'){
            <mat-form-field appearance="fill" id="posImportStartTime-field" class="col-span-1 w-36">
              <mat-label class="custom-label-error">{{ translationService.translate('startTimeText') }}</mat-label>
              <input
                id="posImportStartTime-input"
                matInput
                type="text"
                [matTimepicker]="minutesPicker"
                [formControlName]="'posImportStartTime'"
              />
              <mat-timepicker-toggle matIconSuffix [for]="minutesPicker" />
              <mat-timepicker interval="5min" #minutesPicker />
            </mat-form-field>
            } @if (posDetailsForm.get('posImportOnce').value === 'N'){
            <div class="flex flex-row gap-5 items-center">
              <p id="im-fr">{{ this.translationService.translate('everyMinsText').split(' ')[0] }}</p>
              <input
                id="posImportTimeInterval-input"
                matInput
                type="number"
                min="0"
                max="99999"
                [attr.aria-label]="translationService.translate('everyMinsText')"
                [formControlName]="'posImportTimeInterval'"
              />
              <p id="im-fr">{{ this.translationService.translate('everyMinsText').split(' ').slice(1).join(' ') }}</p>
              @if (posDetailsForm.get('posImportTimeInterval').hasError('required')) {
              <mat-error>{{ translationService.translate('requiredText') }}</mat-error>
              }
            </div>
            }
            <div class="grid grid-cols-2 gap-5 items-center">
              <p id="customer-label" class="pr-5">{{ translationService.translate('customerText') }}</p>
              <mat-slide-toggle id="posImportCustomer-toggle" formControlName="posImportCustomer">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-5 gap-5 items-center">
            <div></div>
            <div></div>
            <div class="grid grid-cols-2 gap-5 items-center">
              <p id="inventory-label" class="pr-5">{{ translationService.translate('inventoryText') }}</p>
              <mat-slide-toggle id="posImportInventory-toggle" formControlName="posImportInventory">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-5 gap-5 items-center">
            <div></div>
            <div></div>
            <div class="grid grid-cols-2 gap-5 items-center">
              <p id="invoicingResults-label" class="pr-5">{{ translationService.translate('invoicingResultsText') }}</p>
              <mat-slide-toggle id="posImportInvoice-toggle" formControlName="posImportInvoice">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('posExportSetupText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-cols-5 gap-5 items-center">
          <p id="im-fr" class="pr-5 pos-section-label">
            {{ translationService.translate('productionExportBFileText') }}
          </p>
          <div class="col-span-3 flex items-center justify-end gap-3">
            @if (exportJobSummary) { @if (exportJobSummary.activeJobCount > 0) {
            <span class="job-status-dot running"></span>
            <span class="pos-job-status-text running">Running...</span>
            } @else if (exportJobSummary.lastScheduleTime) {
            <span class="job-status-dot completed"></span>
            <span class="pos-job-status-text">Last run: {{ formatDateWithTimezone(exportJobSummary.lastScheduleTime) }}</span>
            } @else {
            <span class="job-status-dot idle"></span>
            <span class="pos-job-status-text">Schedule: {{ exportJobSummary.schedule || 'N/A' }} &mdash; Never run</span>
            } } @else if (kubeJobsLoading) {
            <span class="pos-job-status-text">Loading job status...</span>
            } @else {
            <span class="job-status-dot idle"></span>
            <span class="pos-job-status-text">Job status unavailable</span>
            }
          </div>
          <div class="flex justify-end">
            <button
              class="pos-job-button btn-primary"
              id="run-export-button"
              type="button"
              mat-flat-button
              color="primary"
              (click)="runExport()"
              [disabled]="triggeringExport"
            >
              <mat-icon>cloud_download</mat-icon>
              {{ translationService.translate('runExportText') }}
            </button>
          </div>
        </div>
        <div class="flex flex-row gap-5 items-center">
          <div class="grid grid-cols-2 gap-5 items-center">
            <p id="exportToFile-label" class="pr-5">{{ translationService.translate('exportToFileText') }}</p>
            <mat-slide-toggle id="posExportToFile-toggle" formControlName="posExportToFile">
              {{ translationService.translate('yesText') }}
            </mat-slide-toggle>
          </div>
          <p id="im-fr" class="ml-5 pr-5">{{ translationService.translate('frequencyOfExportText') }}</p>
          <div class="flex flex-row gap-5 items-center">
            <p id="im-fr">{{ this.translationService.translate('everyMinsText').split(' ')[0] }}</p>
            <input
              id="posExportTimeInterval-input"
              [size]="6"
              matInput
              type="number"
              min="0"
              max="99999"
              [attr.aria-label]="translationService.translate('everyMinsText')"
              [formControlName]="'posExportTimeInterval'"
            />
            <p id="im-fr" class="pr-5">{{ this.translationService.translate('everyMinsText').split(' ').slice(1).join(' ') }}</p>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="grid grid-rows-4 mt-3">
          <div class="grid grid-cols-5 gap-5 items-center">
            <p id="im-fr" class="pr-5 pos-section-label">
              {{ translationService.translate('btDownloadExportText') }}
            </p>
            @if (posDetailsForm.get('btdActivated').value === true){
            <div class="col-span-3 flex items-center justify-end gap-3">
              @if (btdExportJobSummary) { @if (btdExportJobSummary.activeJobCount > 0) {
              <span class="job-status-dot running"></span>
              <span class="pos-job-status-text running">Running...</span>
              } @else if (btdExportJobSummary.lastScheduleTime) {
              <span class="job-status-dot completed"></span>
              <span class="pos-job-status-text">Last run: {{ formatDateWithTimezone(btdExportJobSummary.lastScheduleTime) }}</span>
              } @else {
              <span class="job-status-dot idle"></span>
              <span class="pos-job-status-text">Schedule: {{ btdExportJobSummary.schedule || 'N/A' }} &mdash; Never run</span>
              } } @else if (kubeJobsLoading) {
              <span class="pos-job-status-text">Loading job status...</span>
              } @else {
              <span class="job-status-dot idle"></span>
              <span class="pos-job-status-text">Job status unavailable</span>
              }
            </div>
            <div class="flex justify-end">
              <button
                class="pos-job-button btn-primary"
                id="run-btd-export-button"
                type="button"
                mat-flat-button
                color="primary"
                (click)="runBtdExport()"
                [disabled]="triggeringBtdExport"
              >
                <mat-icon>cloud_download</mat-icon>
                {{ translationService.translate('runBtdExportText') }}
              </button>
            </div>
            }
          </div>
          <div class="flex flex-row items-center gap-4">
            <div class="grid grid-cols-2 gap-5 items-center">
              <p id="status-label">{{ translationService.translate('activateBtDownloadExportText') }}</p>
              <mat-slide-toggle id="status-switch" formControlName="btdActivated">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
          @if (posDetailsForm.get('btdActivated').value === true){
          <div class="flex flex-row items-center gap-4">
            <div class="grid grid-cols-2 gap-5 items-center">
              <p id="exportToFile-label" class="pr-5">{{ translationService.translate('exportToFileText') }}</p>
              <mat-slide-toggle id="btdExportToFile-toggle" formControlName="btdExportToFile">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
          <div class="grid grid-cols-5 gap-5 items-center">
            <mat-radio-group formControlName="btdExportOnce" class="flex flex-row gap-4">
              <mat-radio-button id="btdExportOnce-daily-radio" [checked]="posDetailsForm.get('btdExportOnce').value === 'Y'" value="Y">
                {{ translationService.translate('onceDailyText') }}
              </mat-radio-button>
              <mat-radio-button id="btdExportOnce-repeat-radio" [checked]="posDetailsForm.get('btdExportOnce').value === 'N'" value="N">
                {{ translationService.translate('repeatDailyText') }}
              </mat-radio-button>
            </mat-radio-group>
            @if (posDetailsForm.get('btdExportOnce').value === 'Y'){
            <mat-form-field appearance="fill" id="btdExportStartTime-field" class="col-span-1 w-36">
              <mat-label class="custom-label-error">{{ translationService.translate('startTimeText') }}</mat-label>
              <input
                id="btdExportStartTime-input"
                matInput
                type="text"
                [matTimepicker]="minutesPicker"
                [formControlName]="'btdExportStartTime'"
              />
              <mat-timepicker-toggle matIconSuffix [for]="minutesPicker" />
              <mat-timepicker interval="5min" #minutesPicker />
            </mat-form-field>
            } @if (posDetailsForm.get('btdExportOnce').value === 'N'){
            <div class="flex flex-row gap-5 items-center">
              <p id="im-fr" class="pr-5">{{ this.translationService.translate('everyMinsText').split(' ')[0] }}</p>
              <input
                id="btdExportTimeInterval-input"
                [size]="6"
                matInput
                type="number"
                min="0"
                max="99999"
                [attr.aria-label]="translationService.translate('everyMinsText')"
                [formControlName]="'btdExportTimeInterval'"
              />
              <p id="im-fr">{{ this.translationService.translate('everyMinsText').split(' ').slice(1).join(' ') }}</p>
              @if (posDetailsForm.get('btdExportTimeInterval').hasError('required')) {
              <mat-error>{{ translationService.translate('requiredText') }}</mat-error>
              }
            </div>
            }
          </div>
          <div class="flex flex-row items-center gap-4">
            <p>{{ translationService.translate('dataToExportText') }}</p>
            <mat-radio-group formControlName="btdExportAll" class="flex flex-row items-center gap-4">
              <mat-radio-button id="all-radio-button" [checked]="posDetailsForm.get('btdExportAll').value === 'Y'" value="Y">
                {{ translationService.translate('allText') }}
              </mat-radio-button>
              <mat-radio-button id="inProcess-radio-button" [checked]="posDetailsForm.get('btdExportAll').value === 'N'" value="N">
                {{ translationService.translate('inProcessOnlyText') }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</div>
